import cpfCnpj from 'cpf_cnpj';
import * as types from '../types';

const { CNPJ } = cpfCnpj;
const broker = JSON.parse(localStorage.getItem('broker'));

export const actionPolicyHolderSucceeded = data => ({
  type: types.FETCH_POLICY_HOLDERS_SUCCEEDED,
  payload: data
});

export const actionPolicyHolderFailed = error => ({
  type: types.FETCH_POLICY_HOLDERS_FAILED,
  payload: error
});

export const fetchPolicyHolders = (
  page = 1,
  offset = 10,
  policyHolder
) => async (dispatch, getState, { RepositoryAPI, NovoCotadorAPI }) => {
  dispatch({ type: types.REQUEST_POLICY_HOLDERS_DATA });

  const response = !CNPJ.isValid(CNPJ.strip(policyHolder))
    ? await RepositoryAPI.BuscarTomadorAutocomplete(page, offset, policyHolder)
    : await NovoCotadorAPI.FixedpolicyHolderSearch(
        broker.externalId,
        CNPJ.strip(policyHolder)
      );

  if (response.status === 200 && response.data) {
    const dataResponse = response.data.records || [response.data];
    const numberOfRecords = response.data.numberOfRecords || [response.data];
    let list = [];

    if (numberOfRecords && numberOfRecords > 0) {
      list = dataResponse.map(item => {
        return {
          value: item.ExternalId || item.id,
          label: item.CompanyName || item.name,
          federalId: item.federalId || item.FederalId,
          ...item
        };
      });
    }
    return dispatch(actionPolicyHolderSucceeded(list));
  }

  return dispatch(actionPolicyHolderFailed(response.error));
};

export const resetPolicyHolders = () => ({
  type: types.RESET_POLICY_HOLDERS
});
